import { GWP8238AcquisitionBanner } from '@/patterns/adg4/enhanced-banner-alert/gwp-8238-acquisition-banner';

export const JiraSoftwarePageBannerAlert = () => {
	return (
		<GWP8238AcquisitionBanner
			productKey="jiraSoftware"
			identifier="JiraSoftwarePageTemplate.banner.gwp-8238-announcement"
			ufoSegmentName="jira-software-bannerAlert-gwp8238"
			testId="gwp-8238-announcement-jira"
			linkTextId="JiraSoftwarePage.banner-alert.gwp-8238-announcement.link-text"
			linkTextDefault="Learn more"
		/>
	);
};
